"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RiskAssessmentVaidationMode = exports.CTOMessageType = void 0;
var CTOMessageType;
(function (CTOMessageType) {
    CTOMessageType["GFMO"] = "GFMO";
    CTOMessageType["RETAIL"] = "RETAIL";
    CTOMessageType["MAXATTEMPTS"] = "PIN_VALIDATION_MAXATTEMPTS";
    CTOMessageType["OTHERS"] = "EVERGENT_ERROR_OTHERS";
    CTOMessageType["PAYMENT_FAILURE"] = "PAYMENT_FAILURE";
    CTOMessageType["ORDER_SUBMIT_FAILURE_TYPE_1"] = "ORDER_SUBMIT_FAILURE_SOrder-S-1004";
    CTOMessageType["ORDER_SUBMIT_FAILURE_TYPE_2"] = "ORDER_SUBMIT_FAILURE_Service-I-1020";
    CTOMessageType["SHIPPING_FAILURE_OUT_OF_STOCK"] = "SHIPPING_FAILURE_OUT_OF_STOCK";
    CTOMessageType["SHIPPING_FAILURE_INSUFFICIENT_INVENTORY"] = "SHIPPING_FAILURE_INSUFFICIENT_INVENTORY";
    CTOMessageType["TRADE_IN_DISPLAY_FAILURE"] = "TRADE_IN_DISPLAY_FAILURE";
    CTOMessageType["NO_COMMON_SHIPPING_OPTIONS"] = "NO_COMMON_SHIPPING_OPTIONS";
    CTOMessageType["SIM_SWAP_ERROR"] = "SIM-1013";
    CTOMessageType["AUTO_BILL_PAY_ERROR"] = "AutoBill-1001";
    CTOMessageType["ABUSIVE_BY_CUSTOMER"] = "CreditCheck-A-1008";
    CTOMessageType["BILL_PREFERENCE_POST_ERROR"] = "BILL_PREFERENCE_POST_CTO";
    CTOMessageType["SMB_WIRELESS_CREDIT_CHECK_FAILURE"] = "SMB_WIRELESS_CREDIT_CHECK_FAILURE";
})(CTOMessageType = exports.CTOMessageType || (exports.CTOMessageType = {}));
var RiskAssessmentVaidationMode;
(function (RiskAssessmentVaidationMode) {
    RiskAssessmentVaidationMode["SMS_ONLY"] = "sms_only";
    RiskAssessmentVaidationMode["EMAIL_ONLY"] = "email_only";
    RiskAssessmentVaidationMode["SMS_OR_EMAIL"] = "sms_or_email";
    RiskAssessmentVaidationMode["SMS_AND_EMAIL"] = "sms_and_email";
})(RiskAssessmentVaidationMode = exports.RiskAssessmentVaidationMode || (exports.RiskAssessmentVaidationMode = {}));
//# sourceMappingURL=CheckoutPOSTResponse.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/models/responses/CheckoutPOSTResponse.js
// module id = 819
// module chunks = 8